module.exports = __webpack_public_path__ + "media/images/responsive/costumes/icon_sliders-2b7724b6931d82b2ff25491eff199f7a.svg";